interface IconProps {
  className?: string;
}

/** Chevron glyph of the fold buttons on the DubaiExpress product page. */
const ChevronDownIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden className={className}>
    <path
      d="M4 6l4 4 4-4"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronDownIcon;
